import { useState } from 'react'
import './styles.scss'
import { connect } from 'react-redux'
import {
  setCurrentJoinStep,
  setSelectedProduct,
} from '../../../redux/join/join.actions'
import { sendToCheckout } from '../../../utils/firebase/firebase'
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Paper,
  Typography,
} from '@mui/material'
import AdjustOutlinedIcon from '@mui/icons-material/AdjustOutlined'
import { convertCycle } from '../about-you/helpers'

function Package({
  membership,
  currentUser,
  setCurrentJoinStep,
  setSelectedProduct,
}) {
  const {
    price,
    cycle,
    stripeAPI,
    type,
    discountTitle,
    description,
    attributes,
    popular,
  } = membership
  const priceMain = price.slice(0, -2)
  const priceDecimal = price.slice(-2)
  const [submitting, setSubmitting] = useState(false)

  const handleOnClick = () => {
    setSubmitting(true)
    if (!currentUser) {
      setCurrentJoinStep(3)
      setSelectedProduct({
        priceMain,
        priceDecimal,
        cycle,
        stripeAPI,
        type,
        discountTitle,
        description,
        attributes,
      })
      console.log('No user - register & checkout')
    } else {
      setSelectedProduct({
        priceMain,
        priceDecimal,
        cycle,
        stripeAPI,
        type,
        description,
        attributes,
      })
      console.log('State set. Already a user - checkout only')
      sendToCheckout(stripeAPI, currentUser.id, cycle)
    }
  }

  const featureRow = (icon, primary, secondary) => (
    <Box display={'flex'} alignItems={'flex-start'} gap={1.25}>
      {icon}
      <Box>
        <Typography lineHeight={1.4}>{primary}</Typography>
        {secondary && (
          <Typography color={'primary'} fontSize={'small'} lineHeight={1.4}>
            {secondary}
          </Typography>
        )}
      </Box>
    </Box>
  )

  const tickIcon = (
    <AdjustOutlinedIcon
      fontSize='small'
      color='primary'
      sx={{ mt: '3px', flexShrink: 0 }}
    />
  )

  return (
    <Paper
      elevation={popular ? 8 : 3}
      variant='outlined'
      sx={{
        position: 'relative',
        overflow: 'visible',
        flexGrow: 1,
        flexShrink: 1,
        flexBasis: 300,
        minWidth: { xs: 0, sm: 280 },
        maxWidth: { xs: '100%', sm: 360 },
        border: (theme) =>
          `${popular ? 2 : 1}px solid ${theme.palette.primary.main}`,
        borderRadius: 2,
        background: popular
          ? 'linear-gradient(180deg, rgba(211,185,8,0.12) 0%, rgba(23,23,23,1) 38%)'
          : 'linear-gradient(180deg, #1f1f1f 0%, #141414 100%)',
        padding: 3,
        pt: popular ? 4 : 3,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        boxShadow: popular ? '0 0 28px rgba(211,185,8,0.35)' : 'none',
        transform: popular ? 'scale(1.02)' : 'none',
        transition:
          'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
        '@media (hover: hover)': {
          '&:hover': {
            transform: popular ? 'scale(1.02) translateY(-6px)' : 'translateY(-6px)',
            borderColor: '#fde025',
            boxShadow: '0 12px 32px rgba(211,185,8,0.4)',
          },
        },
      }}
    >
      {popular && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'primary.main',
            color: 'primary.contrastText',
            px: 1.75,
            py: 0.5,
            borderRadius: 999,
            fontSize: '0.75rem',
            fontFamily: 'Oswald, sans-serif',
            letterSpacing: '1.5px',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            boxShadow: '0 2px 10px rgba(0,0,0,0.5)',
          }}
        >
          Most Popular
        </Box>
      )}
      <Box>
        <Box mb={2}>
          <Typography textAlign={'center'} variant='h6' lineHeight={1.2}>
            {description}
          </Typography>
          <Typography variant='body2' textAlign={'center'} sx={{ minHeight: 20 }}>
            {discountTitle}
          </Typography>
        </Box>

        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'flex-end'}
        >
          <Typography variant='h5' color={'primary'}>
            {cycle}
          </Typography>
          <Typography variant='h4'>
            £{priceMain}.{priceDecimal}
          </Typography>
        </Box>
        <Divider sx={{ mt: 1.5, borderColor: 'rgba(211,185,8,0.3)' }} />
        <Box display={'grid'} gap={1.75} mt={2.5}>
          {type === 'family' &&
            featureRow(tickIcon, 'Household membership', '2 adults & 2 children')}
          {(attributes || []).map((attribute, index) =>
            <Box
              display={'flex'}
              alignItems={'flex-start'}
              gap={1.25}
              key={index + attribute}
            >
              {tickIcon}
              <Typography lineHeight={1.4}>{attribute}</Typography>
            </Box>
          )}

          {cycle !== 'Weekly' &&
            featureRow(tickIcon, '24hr free trial')}
          {featureRow(
            tickIcon,
            `${priceMain} HYVE credits every ${convertCycle(cycle)}`,
            'credits for guest passes, discounted supplements and more'
          )}
        </Box>
      </Box>
      <Button
        fullWidth
        variant='contained'
        sx={{ mt: 3, py: 1.25 }}
        size='large'
        onClick={handleOnClick}
      >
        {submitting ? (
          <CircularProgress size={25} color='secondary' />
        ) : (
          `Join for £${priceMain}.${priceDecimal} ${cycle}`
        )}
      </Button>
    </Paper>
  )
}

const mapStateToProps = ({ user }) => ({
  currentUser: user.currentUser,
})

const mapDispatchToProps = (dispatch) => ({
  setCurrentJoinStep: (joinStep) => dispatch(setCurrentJoinStep(joinStep)),
  setSelectedProduct: (product) => dispatch(setSelectedProduct(product)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Package)
